import React from 'react';
import { FormattedMessage } from 'react-intl';
import RecoilErrorBoundary from '../../components/recoil-error-boundary/RecoilErrorBoundary';
import SelfDiscoveryList from './self-discovery-list/SelfDiscoveryList';
import DefaultListSkeleton from '../../components/default-list-skeleton/DefaultListSkeleton';

function SelfDiscovery() {
  return (
    <div>
      <h2>
        <FormattedMessage id="self-discovery" />
      </h2>
      <React.Suspense fallback={<DefaultListSkeleton />}>
        <RecoilErrorBoundary errorFallback={<DefaultListSkeleton />}>
          <SelfDiscoveryList />
        </RecoilErrorBoundary>
      </React.Suspense>
    </div>
  );
}

export default SelfDiscovery;
